import React from 'react';
import classnames from 'classnames';
import { Icon } from '../../Icon';
import { getClassNames } from './TableHeader.classNames';
import { getSrOnlyStyle, t } from '../../utils';
import { getIconNameForTheadCell, getAriaLabelForTheadCell } from './utils';

/**
 * @deprecated Komponenten er erstattet av Table.Header fra "@skatteetaten/ds-table"
 *
 * visibleName TableHeader (TabellHeader)
 */
export const TableHeader = props => {
  const {
    columns,
    sort,
    setSort
  } = props;
  const styles = getClassNames(props);

  const setSortingState = columnFieldName => setSort({
    ascending: sort.columnFieldName === columnFieldName ? !sort.ascending : true,
    columnFieldName: columnFieldName
  });

  const onKeyDown = (e, fieldName) => {
    return e.key === 'Enter' ? setSortingState(fieldName) : null;
  };

  const thElements = columns && columns.map(key => {
    if (!key.name) {
      // Når kolonnetittel er tom skal ikke kolonnen ha <th />
      return /*#__PURE__*/React.createElement("td", {
        key: key.fieldName,
        className: styles.tabellTheadCellIsEmpty
      });
    }

    if (key.srOnly) {
      return /*#__PURE__*/React.createElement("th", {
        key: key.fieldName,
        className: styles.tabellTheadCellIsEmpty
      }, /*#__PURE__*/React.createElement("span", {
        style: getSrOnlyStyle()
      }, key.name));
    }

    if (key.sortable) {
      const isSorted = sort.columnFieldName === key.fieldName;
      const iconName = getIconNameForTheadCell(isSorted, sort.ascending);
      const ariaLabel = getAriaLabelForTheadCell(key.name, key.fieldName, isSorted, sort.ascending, t);
      return /*#__PURE__*/React.createElement("th", {
        key: key.fieldName,
        className: classnames(styles.tabellTheadCell, styles.tabellTheadCellIsSortable, {
          [styles.tabellTheadCellAlignedRight]: key.alignment === 'right',
          [styles.tabellTheadCellAlignedCenter]: key.alignment === 'center',
          [styles.tabellTheadCellHiddenOnMobile]: key.hideOnMobile
        }),
        tabIndex: 0,
        scope: "col",
        "aria-label": ariaLabel,
        onClick: () => setSortingState(key.fieldName),
        onKeyDown: e => onKeyDown(e, key.fieldName)
      }, key.name, /*#__PURE__*/React.createElement(Icon, {
        iconName: iconName,
        className: !key.autohideSorting ? 'noAutoHide' : undefined
      }));
    }

    return /*#__PURE__*/React.createElement("th", {
      key: key.fieldName,
      className: classnames(styles.tabellTheadCell, {
        [styles.tabellTheadCellAlignedRight]: key.alignment === 'right',
        [styles.tabellTheadCellAlignedCenter]: key.alignment === 'center',
        [styles.tabellTheadCellHiddenOnMobile]: key.hideOnMobile
      }),
      scope: "col"
    }, key.name);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, thElements);
};